import React from 'react';

function SettingsIntegrations() {
  return (
    <div>
      <h1>Settings - Integrations</h1>
      <p>Manage your integration settings here.</p>
    </div>
  );
}

export default SettingsIntegrations;